import { createContext } from 'react';

const DrinkContext = createContext();

export default DrinkContext;
